import { IShortMessage, ShowedMessage } from './MessageEngineTypes'

export const isShortMessage = (message: ShowedMessage | null | undefined): message is IShortMessage => {
  return !!message && message.type === 'shortMessage'
}
